module.exports = __webpack_public_path__ + "static/media/thermostatArrowUp.5b0ad0ec.png";